import { render } from "./Navigation.vue?vue&type=template&id=551823ad&ts=true"
import script from "./Navigation.vue?vue&type=script&lang=ts"
export * from "./Navigation.vue?vue&type=script&lang=ts"

import "./Navigation.vue?vue&type=style&index=0&id=551823ad&lang=css"

import exportComponent from "D:\\Users\\orson\\coding\\thelounge\\thelounge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/Settings/Navigation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "551823ad"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('551823ad', __exports__)) {
    api.reload('551823ad', __exports__)
  }
  
  module.hot.accept("./Navigation.vue?vue&type=template&id=551823ad&ts=true", () => {
    api.rerender('551823ad', render)
  })

}


export default __exports__